module.exports = __webpack_public_path__ + "media/images/favicon-4d47a1c82567e31d5d074b5368f595e7.png";